import { render } from "./vertical-nav.vue?vue&type=template&id=36832bc5&scoped=true"
import script from "./vertical-nav.vue?vue&type=script&lang=js"
export * from "./vertical-nav.vue?vue&type=script&lang=js"

import "./vertical-nav.vue?vue&type=style&index=0&id=36832bc5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36832bc5"]])

export default __exports__